var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9141 11.5332L14.9043 1.70898C14.9043 1.15234 14.543 0.761719 13.957 0.761719H4.13281C3.58594 0.761719 3.21484 1.18164 3.21484 1.65039C3.21484 2.11914 3.63477 2.51953 4.09375 2.51953H7.49219L12.2578 2.36328L10.4414 3.95508L0.763672 13.6523C0.587891 13.8281 0.490234 14.0527 0.490234 14.2676C0.490234 14.7363 0.910156 15.1758 1.39844 15.1758C1.62305 15.1758 1.83789 15.0977 2.01367 14.9121L11.7109 5.22461L13.3223 3.39844L13.1465 7.95898V11.5723C13.1465 12.0312 13.5469 12.4609 14.0254 12.4609C14.4941 12.4609 14.9141 12.0605 14.9141 11.5332Z",
    fill: "#0B0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.e2c6bccb1d286e9edd57d28a08258e49.svg";
export { ForwardRef as ReactComponent };